import axios from 'axios'
import {
  cancelled,
  select,
  fork,
  takeLatest,
  call,
  put,
} from 'redux-saga/effects'

import { baseURL } from 'config'
import {
  formatImageBase64,
} from 'helpers/actionHelper'
import {
  get,
} from 'helpers/RequestUtil'
import {
  updateTablesAction,
} from 'containers/Entity/actions'
import {
  FETCH_APPROVERS_APPROVALS,
  FETCH_APPROVERS,
  FETCH_APPROVER_IMAGE,
} from './constants'
import {
  startFetchApproversApprovalsAsync,
  startFetchApproversAsync,
  startFetchApproverImageAsync,
  clearApprovers,
  updateApprovers,
  updateApproversApprovals,
  updateApproverImage,
  fetchApproversStart,
  fetchApproversSuccess,
  fetchApproversError,
  fetchApproverImageStart,
  fetchApproverImageSuccess,
  fetchApproverImageError,
  fetchApproversApprovalsStart,
  fetchApproversApprovalsSuccess,
  fetchApproversApprovalsError,
} from './actions'
import {
  usernameSelector,
} from './selectors'

function* getApprovers(workflowId) {
  try {
    yield put(startFetchApproversAsync())
    yield put(fetchApproversStart())
    const data = yield call(get, `/api/fulcrum/workflows/${workflowId}/approver_details`)
    const { result: { workflow_approver_details: approvers } } = data

    yield put(updateTablesAction(data))
    yield put(fetchApproversSuccess(approvers))
    return approvers
  } catch(error) {
    yield put(fetchApproversError(error))
  } finally {
    if (yield cancelled()) {
      yield put(clearApprovers())
    }
  }
}

function* getApproversApprovals(workflowId) {
  try {
    yield put(startFetchApproversApprovalsAsync())
    yield put(fetchApproversApprovalsStart())
    const data = yield call(get, `/api/fulcrum/workflows/${workflowId}/approver_approvals`)
    const { result: { workflow_approver_approvals: approvals } } = data

    yield put(updateTablesAction(data))
    yield put(fetchApproversApprovalsSuccess(approvals))
    return approvals
  } catch(error) {
    yield put(fetchApproversApprovalsError(error))
  } finally {
    if (yield cancelled()) {
      yield put(clearApprovers())
    }
  }
}

function* getImage(username) {
  try {
    yield put(startFetchApproverImageAsync())
    yield put(fetchApproverImageStart())
    const { data } = yield call(axios.get, `${baseURL}/api/cftt_external/GetUserPhoto?netlogonId=${username}`)
    const image = formatImageBase64(data)
    const normalized = {
      entities: {
        user_photos: {
          [username]: {
            username,
            image
          }
        }
      },
      result: {
        user_photos: [username]
      }
    }

    yield put(updateTablesAction(normalized))
    yield put(fetchApproverImageSuccess(username))
    return username
  } catch(error) {
    yield put(fetchApproverImageError(error))
  } finally {
    if (yield cancelled()) {
      yield put(clearApprovers())
    }
  }
}

function* fetchApproverImage(userId) {
  const username = yield select(usernameSelector, userId)
  yield call(getImage, username)
  yield put(updateApproverImage(username))
}

function* fetchApprovers(workflowId) {
  const tasks = []
  const approvers = yield call(getApprovers, workflowId)
  yield put(updateApprovers(approvers))
  for (let approver of approvers) {
    let task = yield fork(fetchApproverImage, approver)
    tasks.push(task)
  }
}

function* fetchApproversApprovals(workflowId) {
  const tasks = []
  const approvals = yield call(getApproversApprovals, workflowId)
  yield put(updateApproversApprovals(approvals))
}

function* fetchApproversHandler(action) {
  const { workflowId } = action
  yield call(fetchApprovers, workflowId)
}

function* fetchApproverImageHandler(action) {
  const { username } = action
  yield call(getImage, username)
  yield put(updateApproverImage(username))
}

function* watchFetchApprovers () {
  yield takeLatest(FETCH_APPROVERS, fetchApproversHandler)
}

function* watchFetchApproverImage () {
  yield takeLatest(FETCH_APPROVER_IMAGE, fetchApproverImageHandler)
}

export {
  watchFetchApprovers,
  watchFetchApproverImage,
  fetchApprovers,
  fetchApproversApprovals,
}
